import type { AxiosResponse } from "axios";
import type { IRespuestaApiLista } from "../../globales/interfaces";
import api from "../../utils/api";
import type { IArchivoNbs, IFiltroNbsReporte } from "./entidades/IFiltroNbsReporte";
import type { INbsReporteDisponible } from "./entidades/INbsReporteDisponible";

const MENSAJE_ERROR_POR_DEFECTO = "No se pudo generar el reporte NBS. Intente de nuevo más tarde.";

// Error con el mensaje del backend listo para mostrar al usuario.
export class ErrorReporteNbs extends Error { }

// Con responseType blob los errores de negocio (HTTP 400) llegan como Blob con el JSON del ApiResponse.
const obtenerMensajeError = async (error: unknown): Promise<string> => {
    const { response, mensajeBackend } = (error ?? {}) as { response?: { data?: unknown }; mensajeBackend?: string };
    const data = response?.data;
    if (data instanceof Blob) {
        try {
            const json = JSON.parse(await data.text());
            if (Array.isArray(json?.Messages) && json.Messages.length > 0) return json.Messages[0];
        } catch {
            // Cuerpo no JSON: se usa el mensaje por defecto.
        }
    }
    return mensajeBackend || MENSAJE_ERROR_POR_DEFECTO;
};

const obtenerNombreArchivo = (respuesta: AxiosResponse<Blob>, nombrePorDefecto: string): string => {
    const cd: string = respuesta.headers["content-disposition"] ?? "";
    const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(cd)?.[1];
    if (utf8) return decodeURIComponent(utf8.trim());
    return /filename="?([^";]+)"?/i.exec(cd)?.[1]?.trim() || nombrePorDefecto;
};

export class NbsReportesModelo {

    constructor() { }

    public async obtenerDisponibles(filtro: IFiltroNbsReporte, incluirNoAprobadas = false): Promise<IRespuestaApiLista<INbsReporteDisponible>> {
        const { data } = await api.get(`/api/NbsReportes/Disponibles`, {
            params: { ...filtro, incluirNoAprobadas }
        });
        return data;
    }

    public async obtenerPdfVisita(visitaId: number): Promise<IArchivoNbs> {
        try {
            // Sin timeout: cada PDF tarda varios segundos en generarse en el servidor.
            const respuesta = await api.get<Blob>(`/api/NbsReportes/Visita/${visitaId}`, {
                params: { descargar: true },
                responseType: "blob",
                timeout: 0
            });
            return {
                blob: respuesta.data,
                nombre: obtenerNombreArchivo(respuesta, `Reporte_NBS_${visitaId}.pdf`),
                tipo: respuesta.headers["content-type"] ?? respuesta.data.type ?? ""
            };
        } catch (error) {
            throw new ErrorReporteNbs(await obtenerMensajeError(error));
        }
    }
}
